import {
    createCombinedReducer,
    createModuleFactory,
    IModuleFactory,
} from '@omaze/redux';
import { Reducer } from 'redux';

import { disableActionReducer } from './actions/Disable/Disable';
import { enableActionReducer } from './actions/Enable/Enable';
import { registerActionReducer } from './actions/Register/Register';
import { unregisterActionReducer } from './actions/Unregister/Unregister';
import { FEATURE_FLAG_NAMESPACE } from './FeatureFlag.factory';
import { IFeatureFlagState } from './FeatureFlag.state';

export const initialState: IFeatureFlagState = {
    flags: {},
};

export const featureFlagReducer: Reducer<IFeatureFlagState> = createCombinedReducer<
IFeatureFlagState
>(
    [
        disableActionReducer,
        enableActionReducer,
        registerActionReducer,
        unregisterActionReducer,
    ],
    initialState,
);

export const getFeatureFlagModule: IModuleFactory = createModuleFactory(
    FEATURE_FLAG_NAMESPACE,
    featureFlagReducer,
    [],
);
